<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-row
                no-gutters
                class="mb-4"
            >
                <v-col class="title">
                    {{ $t('Connect e-conomic') }}
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
                class="mb-8"
            >
                <v-col
                    class="body-2"
                >
                    {{ $t('Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.') }}
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
            >
                <v-col cols="12" class="font-weight-medium body-2 mb-4">
                    {{ $t('Step {0}').format(1) }}
                </v-col>
                <v-col
                    class="primary--text"
                >
                    <a href="/api/economic/navigate_agreement_token" target="_blank" class="d-inline-block" style="text-decoration: none">
                        <div class="d-flex">
                            {{ $t('Get agreement ID') }}
                            <v-icon class="ml-1" color="primary">
                                mdi-open-in-new
                            </v-icon>
                        </div>
                    </a>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
                class="mt-8"
            >
                <v-col
                    class="pb-5"
                    cols="4"
                >
                    <div class="font-weight-medium body-2 mb-4">
                        {{ $t('Step {0}').format(2) }}
                    </div>
                    <div class="g5--text">
                        {{ $t('Insert agreement ID') }}
                    </div>
                </v-col>
                <v-col>
                    <password-field
                        :value="controller.model.getAgreementToken()"
                        @input="controller.setAgreementToken($event)"
                    />
                </v-col>
            </v-row>
            <v-row
                no-gutters
                justify="end"
            >
                <v-col
                    class="shrink mt-1"
                >
                    <primary-button
                        :disabled="!controller.model.getAgreementToken()"
                        :loading="controller.model.isLoading()"
                        @click="handleSave"
                    >
                        {{ $t("Connect") }}
                    </primary-button>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import Controller from "../controller"
import {APP_STORE_APP_TYPES} from "@/helpers/constants";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";

export default {
    name: "AppStoreDialogImportConnect",
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props, ctx) {
        const {appStoreDialogActions} = appStoreDialog();
        const handleSave = async () => {
            await props.controller.handleSave()
            await appStoreDialogActions.fetchAppData(APP_STORE_APP_TYPES.ECONOMIC, props.controller.model.getSelectedCompanyId())
        }
        return {
            handleSave
        }
    }
};
</script>
